export const ApelationTableHelpers = {
    data() {
        return {
            tableColumns: [{
                    title: this.$t('Área'),
                    type: 'text',
                    key: 'accreditation_area',
                },
                {
                    title: this.$t('Actividad'),
                    type: 'text',
                    key: 'accreditation_activity',
                },
                {
                    title: this.$t('Tipo'),
                    type: 'text',
                    key: 'accreditation_type',
                },
                {
                    title: this.$t('Fecha creación'),
                    type: 'text',
                    key: 'created_at',
                },
            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}